import styled, {css} from "styled-components"

import {minWidthMedia} from "@irati/ui/src/global/media"
import padding from "@irati/ui/src/global/padding"
import {greys} from "@irati/ui/src/global/colors"

export default styled.div`
  position: relative;
  background-color: ${greys.black};
  ${({dealColor, src}) => {
    if (dealColor) {
      return css`
        background-color: ${dealColor};
      `
    }
    return css`
        background-image: url('${src}');
        background-repeat: no-repeat;
        background-position: top center;
        background-size: cover;
      `
  }}

  text-align: center;
  padding: ${padding.base} 0;

  ${minWidthMedia.tablet`
    margin-bottom: ${padding.tiny};
    padding: 100px 0;
    min-height: 340px;
    text-align: left;
  `}

  a:hover, a:focus {
    text-decoration: none;
  }

  &:before {
    content: " ";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.37);
  }
`
